import React, { useState } from "react";
import { useRouter, Link } from "../router";
import { useAuth } from "../auth-context";
import { peekPendingAction, resumePendingAction } from "../pendingAction";

export default function LoginPage() {
  const { login } = useAuth();
  const { navigate } = useRouter();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  // Read (without consuming) whatever the visitor was trying to do before
  // being sent here - e.g. redeeming a voucher or enrolling - so we can tell
  // them it'll pick back up automatically instead of just showing a bare
  // login form with no context for why they're here.
  const [pending] = useState(() => peekPendingAction());

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    try {
      await login(email, password);
      const handled = await resumePendingAction(navigate);
      if (!handled) navigate("/dashboard");
    } catch (err) {
      setError(err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="page page-narrow">
      <div className="auth-card">
        <h1>Log in</h1>
        {pending && (
          <div className="alert alert-warning">
            {pending.type === "voucher"
              ? "Log in to finish redeeming your voucher code."
              : "Log in to continue enrolling in this course."}
          </div>
        )}
        {error && <div className="alert alert-error">{error}</div>}
        <form onSubmit={submit} autoComplete="on">
          <label>
            Email
            <input
              type="email"
              name="email"
              autoComplete="username"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </label>
          <label>
            Password
            <input
              type="password"
              name="password"
              autoComplete="current-password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </label>
          <button className="btn btn-primary btn-block" disabled={busy}>
            {busy ? "Logging in…" : "Log in"}
          </button>
        </form>
        <p className="muted" style={{ marginTop: 16 }}>
          No account? <Link to="/register">Sign up</Link>
        </p>
        <p className="muted">
          <Link to="/forgot-password">Forgot password?</Link>
        </p>
      </div>
    </div>
  );
}
